import { AxiosResponse } from 'axios';
import {
  EndPauseDTO,
  GetPausesResponseDTO,
  PauseIteration,
  PauseIterationApi,
  StartPauseDTO
} from '../api-client/generated';

const pauseIterationApi = new PauseIterationApi();

/**
 * Get all pauses with summary for a calendar event iteration
 * @param calendarEventIterationId - Calendar event iteration ID
 * @returns GetPausesResponseDTO with pauses array and summary
 */
async function getPausesWithSummary(
  calendarEventIterationId: number
): Promise<GetPausesResponseDTO> {
  try {
    const response: AxiosResponse<GetPausesResponseDTO> =
      await pauseIterationApi.pauseIterationGetPausesWithSummary({
        calendarEventIterationId
      });
    return response.data;
  } catch (error: any) {
    throw new Error(
      `Error getting pauses with summary: ${error.message || error}`
    );
  }
}

/**
 * Start a new pause iteration
 * @param startPauseDTO - Pause start data
 * @returns PauseIteration created
 */
async function startPause(
  startPauseDTO: StartPauseDTO
): Promise<PauseIteration> {
  try {
    const response: AxiosResponse<PauseIteration> =
      await pauseIterationApi.pauseIterationStartPause({
        startPauseDTO
      });
    return response.data;
  } catch (error: any) {
    throw new Error(`Error starting pause: ${error.message || error}`);
  }
}

/**
 * End an active pause iteration
 * @param endPauseDTO - Pause end data
 * @returns PauseIteration updated
 */
async function endPause(endPauseDTO: EndPauseDTO): Promise<PauseIteration> {
  try {
    const response: AxiosResponse<PauseIteration> =
      await pauseIterationApi.pauseIterationEndPause({
        endPauseDTO
      });
    return response.data;
  } catch (error: any) {
    throw new Error(`Error ending pause: ${error.message || error}`);
  }
}

const pauseIterationApiExport = {
  endPause,
  getPausesWithSummary,
  startPause
};

export default pauseIterationApiExport;
